import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';

export default makeStyles((theme: Theme) => ({
  padding: {
    padding: theme.spacing(1),
  },
}));
